import { useHotkeys } from "react-hotkeys-hook"
import { updateDrawer } from "src/shared/store/slices/pos-common"
import { useTypedDispatch } from "src/shared/store/store"
import keysMapped from "./keys-mapper"

const useCustomHotkeys = () => {
  const dispatch = useTypedDispatch()
  useHotkeys(keysMapped.partnersDrawer, (event) => {
    event.preventDefault()
    dispatch(updateDrawer({ key: "partnersDrawer", value: true }))
  })
}

export default useCustomHotkeys
